import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrivateModeProtectionIcon = function PrivateModeProtectionIcon(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? "#000" : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: size,
    height: size,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_14706_3013)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M2.5 9.66663H17.5",
        stroke: stroke,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.16669 9.66671V6.33337C4.16669 5.67033 4.43008 5.03445 4.89892 4.56561C5.36776 4.09677 6.00365 3.83337 6.66669 3.83337H13.3334C13.9964 3.83337 14.6323 4.09677 15.1011 4.56561C15.57 5.03445 15.8334 5.67033 15.8334 6.33337V9.66671",
        stroke: stroke,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.33331 14.6666C3.33331 14.9949 3.39798 15.32 3.52361 15.6233C3.64925 15.9266 3.8334 16.2022 4.06555 16.4344C4.29769 16.6665 4.57329 16.8507 4.8766 16.9763C5.17992 17.102 5.50501 17.1666 5.83331 17.1666C6.16162 17.1666 6.48671 17.102 6.79002 16.9763C7.09334 16.8507 7.36893 16.6665 7.60108 16.4344C7.83323 16.2022 8.01738 15.9266 8.14301 15.6233C8.26865 15.32 8.33331 14.9949 8.33331 14.6666C8.33331 14.3383 8.26865 14.0132 8.14301 13.7099C8.01738 13.4066 7.83323 13.131 7.60108 12.8989C7.36893 12.6667 7.09334 12.4826 6.79002 12.3569C6.48671 12.2313 6.16162 12.1666 5.83331 12.1666C5.50501 12.1666 5.17992 12.2313 4.8766 12.3569C4.57329 12.4826 4.29769 12.6667 4.06555 12.8989C3.8334 13.131 3.64925 13.4066 3.52361 13.7099C3.39798 14.0132 3.33331 14.3383 3.33331 14.6666Z",
        stroke: stroke,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.6667 14.6666C11.6667 15.3297 11.9301 15.9656 12.3989 16.4344C12.8678 16.9032 13.5036 17.1666 14.1667 17.1666C14.8297 17.1666 15.4656 16.9032 15.9345 16.4344C16.4033 15.9656 16.6667 15.3297 16.6667 14.6666C16.6667 14.0036 16.4033 13.3677 15.9345 12.8989C15.4656 12.43 14.8297 12.1666 14.1667 12.1666C13.5036 12.1666 12.8678 12.43 12.3989 12.8989C11.9301 13.3677 11.6667 14.0036 11.6667 14.6666Z",
        stroke: stroke,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.33331 14.6666H11.6666",
        stroke: stroke,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_14706_3013",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white",
          transform: "translate(0 0.5)"
        })
      })
    })]
  }));
};
export default PrivateModeProtectionIcon;